<template>
  <div class="w-full h-full">
    <div>
      <div class="flex justify-between items-center" v-if="compType === 'page'">
        <div v-if="pageType === 'read'">
          <el-page-header @back="$emit('cancel')" content="试题详情"></el-page-header>
        </div>
        <div v-else class="title mb-10px cursor-pointer text-14px">
          <span class="border-l-3 border-color-primary pl-10px text-18px">{{
            pageType === 'create' ? '新增题源' : '编辑题源'
          }}</span>
        </div>
      </div>
    </div>
    <div
      v-loading="pageLoading"
      class="w-full overflow-y-auto overflow-x-hidden pr-20px"
      :class="[pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form v-if="showFormData" ref="topicOriginForm" label-width="140px" :model="formData">
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="考题类型"
              prop="examType"
              :rules="[
                {
                  required: true,
                  message: `请选择考题类型`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                class="w-full"
                v-model="formData.examType"
                placeholder="请选择考题类型"
                filterable
                :disabled="pageType === 'read'"
                @change="selectChange"
              >
                <el-option
                  v-for="item in questionList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="编号" prop="no">
              <el-input
                placeholder="请输入编号"
                v-model="formData.no"
                :disabled="pageType === 'read'"
                size="small"
                clearable
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="知识点所在章节"
              prop="chapterSelect"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-cascader
                class="w-full"
                v-model="formData.chapterSelect"
                :options="treeData"
                :disabled="pageType === 'read'"
                clearable
                :props="{ value: 'id', label: 'name', children: 'children' }"
              ></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="题目重要性" prop="importance">
              <el-select
                v-model="formData.importance"
                placeholder="请选择"
                :disabled="pageType === 'read'"
                class="w-full"
              >
                <el-option
                  v-for="item in questionImportantList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="ml-140px title mb-10px cursor-pointer text-14px">
              <span class="required-text--color">*</span>题目（题干内容）
            </div>
            <el-form-item
              prop="topic"
              :rules="[
                {
                  required: true,
                  message: `请输入标题内容`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-input
                v-model="formData.topic"
                type="textarea"
                :rows="4"
                placeholder="请输入标题内容"
                maxlength="500"
                show-word-limit
                clearable
                :disabled="pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="24">
            <div class="ml-140px title mb-10px cursor-pointer text-14px">
              题目配图
            </div>
            <el-form-item prop="topicIllustrated">
              <img-upload
                :key="formData.topicIllustrated"
                v-model="formData.topicIllustrated"
                :accept="['jpg', 'png', 'jpeg', 'bmp']"
                :uploadWidth="120"
                :uploadHeight="120"
                :isDisabledUploadComponent="pageType === 'read'"
                :isShowDeleteButton="pageType !== 'read'"
              ></img-upload>
            </el-form-item>
          </el-col> -->
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            v-if="[0, 1, 2].includes(formData.examType)"
          >
            <div class="ml-140px title mb-10px cursor-pointer text-14px">
              <span class="required-text--color" v-if="[3, 4].includes(formData.examType)">*</span
              >选项（{{ tip }}）
            </div>
            <div v-for="(item, index) in formData.answerList" :key="index">
              <el-form-item
                :prop="
                  [0, 1].includes(formData.examType) && index > formData.examType + 1
                    ? null
                    : 'answerList.' + index + '.content'
                "
                :rules="
                  [0, 1].includes(formData.examType) && index > formData.examType + 1
                    ? null
                    : [
                        {
                          required: true,
                          message: `请输入选项内容`,
                          trigger: ['change', 'blur'],
                        },
                      ]
                "
              >
                <div class="flex justify-between items-center">
                  <p>
                    <span class="pr-20px"
                      ><span
                        v-if="![0, 1].includes(formData.examType) || index <= formData.examType + 1"
                        class="required-text--color"
                        >*</span
                      >{{ words[index] }}</span
                    >
                    <span
                      ><el-checkbox
                        v-model="item.checked"
                        :disabled="pageType === 'read'"
                        @change="(e) => checkChange(e, item, index)"
                        >答案</el-checkbox
                      ></span
                    >
                  </p>
                  <div>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="addAnswer(index)"
                      v-if="formData.examType !== 2 && formData.answerList.length < 26"
                      >添加</el-button
                    >
                    <el-button
                      size="mini"
                      type="danger"
                      @click="deleteAnswer(index)"
                      v-if="
                        (formData.examType === 0 && formData.answerList.length > 2) ||
                        (formData.examType === 1 && formData.answerList.length > 2)
                      "
                      >删除</el-button
                    >
                  </div>
                </div>
                <div>
                  <el-input
                    v-model="item.content"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入选项内容"
                    maxlength="500"
                    show-word-limit
                    clearable
                    :disabled="pageType === 'read' || formData.examType === 2"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            v-if="[4].includes(formData.examType)"
          >
            <div class="ml-140px title mb-10px cursor-pointer text-14px">
              <span class="required-text--color">*</span>选项（{{ tip }}）
            </div>
            <el-form-item
              prop="correct"
              :rules="[
                {
                  required: true,
                  message: `请输入答案内容`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <quillEditor
                v-model="formData.correct"
                ref="answerParseQuillEditor"
                :class="compType === 'page' ? '' : 'w-440px'"
                :options="editorOption"
                :disabled="pageType === 'read'"
              >
              </quillEditor>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            v-if="[3].includes(formData.examType)"
          >
            <div class="ml-140px title mb-10px cursor-pointer text-14px">
              <span class="required-text--color">*</span>选项（{{ tip }}）
            </div>
            <el-form-item
              prop="correct"
              :rules="[
                {
                  required: true,
                  message: `请输入答案内容`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-input
                v-model="formData.correct"
                placeholder="请输入答案内容"
                :disabled="pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="ml-140px title mb-10px cursor-pointer text-14px">
              <span v-if="[3, 4].includes(formData.examType)" class="required-text--color">*</span
              >答案解析
            </div>
            <el-form-item
              prop="answerAnalysis"
              :rules="
                [3, 4].includes(formData.examType)
                  ? [
                      {
                        required: true,
                        message: `请输入答案解析`,
                        trigger: ['change', 'blur'],
                      },
                    ]
                  : []
              "
            >
              <quillEditor
                v-model="formData.answerAnalysis"
                ref="quillEditor"
                :class="compType === 'page' ? '' : 'w-440px'"
                :options="editorOption"
                :disabled="pageType === 'read'"
              >
              </quillEditor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full flex justify-center items-center mt-5 mb-5" v-if="pageType !== 'read'">
      <el-button
        type="primary"
        size="small"
        @click="submitForm"
        :loading="saveLoading"
        :disabled="pageLoading"
        >保存</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import { QuestionSourceApi } from '@wiz-api/exam-management'
import { wordsList } from '@/components/safety/enumField/enumTagType'
import { typeList, answerList, doubleAnswerList, singleAnswerList } from './EnumField'

const questionSourceApi = new QuestionSourceApi()
export default {
  name: 'topic-origin-form',
  components: {
    quillEditor,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @return {*}
     */
    pageType: {
      type: String,
      default: 'create',
    },
    rowId: {
      type: String,
      default: undefined,
    },
    // 组件类型 dialog弹窗还是page页面
    compType: {
      type: String,
      default: 'page',
    },
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    currentTreeSelect: {
      type: Object,
      default: () => {},
    },
    questionSourceId: {
      type: String,
      default: undefined,
    },
    questionImportantList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    currentTreeSelect: {
      // 监听树选择
      handler(val) {
        this.formData.chapterSelect = [val.parentId, val.id]
      }, // 监听到变化后执行的方法
      deep: true, // 深度监听，内部的对象变化也会触发该事件
      immediate: true, // 立即执行一次
    },
  },
  data() {
    return {
      showFormData: true,
      pageLoading: false,
      words: wordsList,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
            ['blockquote', 'code-block'], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
            [{ script: 'sub' }, { script: 'super' }], // 上标/下标
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            ['clean'], // 清除文本格式
          ],
        },
      },
      // 题目类型
      questionList: typeList,
      // 保存loading
      saveLoading: false,
      formData: {
        importance: 0,
        id: undefined,
        examType: 0,
        topic: '',
        answerAnalysis: '',
        correct: '',
        answerList: [],
        topicContent: '',
        topicIllustrated: undefined,
        chapterSelect: [],
      },
    }
  },
  computed: {
    tip() {
      let text = '从选项中选择一个作为答案'
      if ([1, 2].includes(this.formData.examType)) {
        text = '从选项中选择一个作为答案'
      } else if ([1].includes(this.formData.examType)) {
        text = '从选项中至少选择两项作为答案'
      } else {
        text = '答案内容'
      }
      return text
    },
  },
  methods: {
    addAnswer(index) {
      this.formData.answerList.splice(index + 1, 0, {
        content: '',
        checked: false,
      })
      this.$nextTick(() => {
        this.formData.answerList.forEach((item, answerIndex) => {
          this.$refs.topicOriginForm.clearValidate(`answerList.${answerIndex}.content`)
        })
      })
    },
    deleteAnswer(index) {
      this.formData.answerList.splice(index, 1)
      this.$nextTick(() => {
        this.formData.answerList.forEach((item, answerIndex) => {
          this.$refs.topicOriginForm.clearValidate(`answerList.${answerIndex}.content`)
        })
      })
    },
    // 获取详情
    async getDetail() {
      this.pageLoading = true
      const [err, res] = await questionSourceApi.getInfro({
        id: this.rowId,
      })
      if (!err) {
        this.formData = { ...res }
        this.formData.chapterSelect = [res.questionBankId, res.chapterId]
        // 单选，多选和判断，解析选项内容
        if ([0, 1, 2].includes(this.formData.examType)) {
          this.$set(this.formData, 'answerList', JSON.parse(this.formData.topicContent))
        }
      } else {
        this.formData = this.$options.data().formData
      }
      this.pageLoading = false
    },
    // 考题类型选择
    selectChange(e) {
      // 类型切换，清空考题
      this.formData.answerAnalysis = ''
      this.formData.correct = ''
      this.formData.topic = ''
      this.formData.topicContent = ''
      this.$refs.topicOriginForm.clearValidate()
      this.getAnswerList(e)
      this.showFormData = false
      this.$nextTick(() => {
        this.showFormData = true
      })
    },
    // 获取答案列表
    getAnswerList(e) {
      switch (e) {
        case 0:
          this.$set(this.formData, 'answerList', _.cloneDeep(answerList))
          break
        case 1:
          this.$set(this.formData, 'answerList', _.cloneDeep(doubleAnswerList))
          break
        case 2:
          this.$set(this.formData, 'answerList', _.cloneDeep(singleAnswerList))
          break
        default:
          break
      }
    },
    // 多选框选中和取消事件
    checkChange(e, item, index) {
      // 单选或者判断，每次选中，取消选中的
      if ([0, 2].includes(this.formData.examType)) {
        _.forEach(this.formData.answerList, (ele) => {
          ele.checked = false
        })
      }
      this.formData.answerList[index].checked = e
    },
    // 提交表单
    async submitForm() {
      this.$refs.topicOriginForm.validate(async (valid) => {
        if (valid) {
          const chooseAnswer = []
          // 单选和判断题获取解析得到的答案
          if ([0, 2].includes(this.formData.examType)) {
            const answerIndex = _.findIndex(this.formData.answerList, (item) => {
              return item.checked
            })
            if (answerIndex !== -1) {
              this.formData.correct = this.words[answerIndex]
            }
            // 多选过滤选中选项得到的答案
          } else if ([1].includes(this.formData.examType)) {
            _.forEach(this.formData.answerList, (item, index) => {
              if (item.checked) {
                chooseAnswer.push(this.words[index])
              }
            })
            if (chooseAnswer && chooseAnswer.length > 0) {
              this.formData.correct = chooseAnswer.join(',')
            }
            // 简答题，填空题，置空选项
          } else {
            this.formData.answerList = undefined
          }
          // 转化选项
          this.formData.topicContent = JSON.stringify(this.formData.answerList)
          // 多选是否选择答案校验，最小长度为2
          if ([1].includes(this.formData.examType) && chooseAnswer.length < 2) {
            this.$message({
              showClose: true,
              message: '请勾选至少两个正确答案',
              type: 'warning',
            })
            return
          }

          // 单选或者判断是否选择答案校验
          if ([0, 2].includes(this.formData.examType) && !this.formData.correct) {
            this.$message({
              showClose: true,
              message: '请勾选正确答案',
              type: 'warning',
            })
            return
          }
          this.saveLoading = true

          const params = {
            ...this.formData,
          }
          delete params.chapterSelect
          if (this.formData.id) {
            params.newQuestionBankId = this.formData.chapterSelect[0]
            params.newQuestionChapterId = this.formData.chapterSelect[1]
            params.questionSourceId = this.questionSourceId
            params.questionChapterId = this.formData.chapterId
            // 编辑
            const [err, res] = await questionSourceApi.update(params.questionSourceId, {
              body: params,
            })

            if (!err) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
            this.saveLoading = false
          } else {
            params.questionBankId = this.formData.chapterSelect[0]
            params.questionChapterId = this.formData.chapterSelect[1]
            // 新增
            const [err, res] = await questionSourceApi.create({ body: params })
            if (!err) {
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
            this.saveLoading = false
          }
        }
      })
    },
  },
  created() {
    if (this.pageType !== 'create') {
      // 获取详情接口
      this.getDetail()
    } else {
      // 获取默认类型为单选题的选项
      this.getAnswerList(this.formData.examType)
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../../../node_modules/quill/dist/quill.core.css';
@import '../../../../node_modules/quill/dist/quill.snow.css';
@import '../../../../node_modules/quill/dist/quill.bubble.css';
.form-nolabel {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
}

.custom-height {
  height: calc(100% - 84px);
}

.detail-height {
  height: calc(100% - 34px);
}

.required-text--color {
  color: #ff3a30;
}
</style>
